import cc from 'classcat';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import css from './SizeGuideTable.module.scss';
/*
Take the head and rows and build the mobile table data if we don't have the data already.
*/

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var getRow = function getRow(rows, idx) {
  return rows.map(function (row) {
    return row[idx];
  });
};

var mobileData = function mobileData(_ref) {
  var flipMobile = _ref.flipMobile,
      headMobile = _ref.headMobile,
      rowsMobile = _ref.rowsMobile,
      head = _ref.head,
      rows = _ref.rows;
  var hMobile = [head[0]];
  var rMobile = [];

  if (!flipMobile) {
    return {
      hMobile: headMobile,
      rMobile: rowsMobile
    };
  }

  hMobile = hMobile.concat(rows.map(function (row) {
    return row[0];
  }));
  var idx = 1;

  for (var i = 0; i < rows[0].length - 1; i += 1) {
    rMobile.push([head[i + 1]].concat(getRow(rows, idx)));
    idx += 1;
  }

  return {
    hMobile: hMobile,
    rMobile: rMobile
  };
};

var SizeGuideTable = function SizeGuideTable(_ref2) {
  var blankColLabel = _ref2.blankColLabel,
      gender = _ref2.gender,
      head = _ref2.head,
      headMobile = _ref2.headMobile,
      includeGender = _ref2.includeGender,
      rows = _ref2.rows,
      rowsMobile = _ref2.rowsMobile,
      subtitle = _ref2.subtitle,
      title = _ref2.title,
      flipMobile = _ref2.flipMobile;

  var _mobileData = mobileData({
    flipMobile: flipMobile,
    headMobile: headMobile,
    head: head,
    rowsMobile: rowsMobile,
    rows: rows
  }),
      hMobile = _mobileData.hMobile,
      rMobile = _mobileData.rMobile;

  var headble = hMobile.length > 0 ? hMobile : head;
  var rowble = rMobile.length > 0 ? rMobile : rows;

  var getHead = function getHead(blankColLabel, th, title) {
    var key = th ? "".concat(title, "-").concat(th) : "".concat(title, "-td");
    var colDescription = blankColLabel !== null && blankColLabel !== void 0 ? blankColLabel : 'Sizing';

    if (th) {
      return /*#__PURE__*/_jsx("th", {
        scope: "col",
        children: th
      }, key);
    }

    return /*#__PURE__*/_jsx("td", {
      "aria-label": colDescription
    }, key);
  };

  return /*#__PURE__*/_jsxs("div", {
    className: css.section,
    id: gender,
    children: [includeGender && gender && /*#__PURE__*/_jsx("h1", {
      className: css.gender,
      children: gender
    }), /*#__PURE__*/_jsx("h2", {
      className: css.title,
      children: title
    }), /*#__PURE__*/_jsx("p", {
      className: css.subtitle,
      dangerouslySetInnerHTML: {
        __html: subtitle
      }
    }), /*#__PURE__*/_jsx("table", {
      className: css.table,
      children: /*#__PURE__*/_jsxs("tbody", {
        children: [/*#__PURE__*/_jsx("tr", {
          children: head.map(function (th) {
            return getHead(blankColLabel, th, title);
          })
        }), rows.map(function (row, index) {
          return /*#__PURE__*/_jsx("tr", {
            children: row.map(function (td, idx) {
              return /*#__PURE__*/_jsx(Fragment, {
                children: idx === 0 ? /*#__PURE__*/_jsx("th", {
                  scope: "row",
                  children: td
                }) : /*#__PURE__*/_jsx("td", {
                  children: td
                })
              }, "d-td-".concat(row[0], "-").concat(head[idx]).concat(td, "-").concat(idx));
            })
          }, "d-tr-".concat(row[0], "-").concat(index));
        })]
      })
    }), /*#__PURE__*/_jsx("table", {
      className: cc([css.table, css.mobile]),
      children: /*#__PURE__*/_jsxs("tbody", {
        children: [/*#__PURE__*/_jsx("tr", {
          children: headble.map(function (th) {
            return /*#__PURE__*/_jsx("th", {
              "aria-hidden": th ? 'false' : 'true',
              scope: "col",
              children: th
            }, "m-th-".concat(th));
          })
        }), rowble.map(function (row) {
          return /*#__PURE__*/_jsx("tr", {
            children: row.map(function (td, idx) {
              return /*#__PURE__*/_jsx(Fragment, {
                children: idx === 0 ? /*#__PURE__*/_jsx("th", {
                  scope: "row",
                  children: td
                }) : /*#__PURE__*/_jsx("td", {
                  children: td
                })
              }, "m-th-".concat(row[0], "-").concat(headble[idx]).concat(td));
            })
          }, "m-tr-".concat(row[0]));
        })]
      })
    })]
  });
};

SizeGuideTable.displayName = 'SizeGuideTable';
/* eslint-disable react/forbid-prop-types */

SizeGuideTable.defaultProps = {
  flipMobile: false,
  headMobile: [],
  gender: '',
  includeGender: false,
  rowsMobile: []
};
SizeGuideTable.propTypes = {
  blankColLabel: PropTypes.string,
  gender: PropTypes.string,
  flipMobile: PropTypes.bool,
  head: PropTypes.array.isRequired,
  headMobile: PropTypes.array,
  includeGender: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  rows: PropTypes.array.isRequired,
  rowsMobile: PropTypes.array,
  subtitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};
export default SizeGuideTable;